import { useState } from "react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

// ROW-ACTIONS-01 · one "Actions ▾" menu per document row (Sales Orders register style).
// Wraps the row's EXISTING action buttons unchanged (same handlers, permission/status
// conditions, confirmations and test ids); each renders as a labelled menu row using
// its title (icon buttons) or its own text. The menu closes after any action click.
export const RowActionsMenu = ({ testId, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex justify-end">
      <DropdownMenu open={open} onOpenChange={setOpen} modal={false}>
        <DropdownMenuTrigger asChild>
          <button type="button" data-testid={testId}
            className="h-7 px-2.5 rounded-sm border border-[var(--border)] text-zinc-300 text-[11px] hover:bg-white/10 whitespace-nowrap">Actions ▾</button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" collisionPadding={8} data-testid={`${testId}-menu`}
          className="row-actions-menu bg-[var(--bg-1)] border-[var(--border)] text-sm min-w-[190px] p-1 flex flex-col gap-0.5"
          onClickCapture={(e) => { if (e.target.closest("button:not([disabled])")) setTimeout(() => setOpen(false), 0); }}>
          {children}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
